// "Take me to that section" across screens (07/10/2026 · the home screen's
// "כל רשימת המעקב" lands on the watchlist, not at the top of the portfolio).
// The target may already be mounted (the phone's carousel keeps screens) or
// not yet: the request waits here, and an event tells a mounted one.
let pending = null;
// A request not taken within REQUEST_MS is dropped: otherwise a later visit
// to that screen, which nobody asked to scroll, would (review).
const REQUEST_MS = 2000;
let expiry = null;
export function requestScroll(id) {
  pending = id;
  clearTimeout(expiry);
  expiry = setTimeout(() => { if (pending === id) pending = null; }, REQUEST_MS);
  setTimeout(() => window.dispatchEvent(new CustomEvent("si-scroll-to", { detail: { id } })), 350);
}
export function takeScroll(id) {
  if (pending !== id) return false;
  pending = null;
  return true;
}
